import type { IPartnerSettings } from '.'

const origAppUrl = {
  development: 'https://localhost/Car.Web.Client.CommonClient',
  test: 'https://broker.cebia.cz/test',
  prep: 'https://broker.cebia.cz/prep',
  production: 'https://broker.cebia.cz/prod'
}

const hosts = [
    'broker-new.cebia.cz'
  , 'broker.cebia.cz'
  // , 'localhost:44470'
]

export const BusinessLease: IPartnerSettings = {
  partner: 'BusinessLease',
  origAppUrl: origAppUrl,
  hosts: hosts
}
